<div class="container">
    <div *ngFor="let option of options; let i = index" [attr.data-testid]="'option'+i">
        <div class="option-item card" [attr.data-category-text]="option.text" *ngIf="validateImage(option.text)">
            <img src="assets/questions/{{option.text}}.svg" 
            class="supermarket-image" 
            [class.selected]="model === option.value"
            (click)="onOptionSelect(option.value)">
        <p class="option-text">{{option.text}}</p>
        </div>
    </div>
</div>
<div *ngFor="let option of options" >
    <div *ngIf="validateText(option.text)">
        <div class="option-default-text" (click)="onOptionSelect(option.value)"> <p>{{option.text}}</p></div>
    </div>
</div>